import colors from './colors';

const semanticColors = {
  primary: colors.primary[500],
  primaryLight: colors.primary[50],
  secondary: colors.secondary[500],
  dark: colors.dark[500],
  bgMuted: colors.primary[50],
  textPrimary: colors.text.primary,
  textSecondary: colors.text.secondary,
  success: colors.success.main,
  error: colors.error.main,
};

const theme = {
  colors: {
    ...colors,
    ...semanticColors,
  },
  fonts: { body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" },
  fontSizes: { xs:'11px', sm:'12px', md:'14px', lg:'16px', xl:'18px', '2xl':'22px', '3xl':'28px', '4xl':'36px' },
  fontWeights: { normal:400, medium:500, semibold:600, bold:700, extrabold:800, black:900 },
  spacing: { 1:'4px', 2:'8px', 3:'12px', 4:'16px', 5:'20px', 6:'24px', 8:'32px', 10:'40px', 12:'48px', 16:'64px' },
  radii: { sm:'6px', md:'10px', lg:'14px', xl:'18px', '2xl':'24px', full:'9999px' },
  shadows: {
    sm:   '0 1px 3px rgba(0,0,0,0.06)',
    md:   '0 4px 12px rgba(0,0,0,0.08)',
    lg:   '0 8px 24px rgba(0,0,0,0.10)',
    xl:   '0 16px 48px rgba(0,0,0,0.14)',
  },
  transitions: { fast:'150ms ease', normal:'250ms ease', slow:'400ms ease' },
  zIndex: { dropdown:100, sticky:200, modal:400, toast:600 },
} as const;

export type Theme = typeof theme;
export default theme;
